import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { roleGuard } from './guards/role.guard';
import { adminGuard } from './guards/admin.guard';

export const routes: Routes = [
  {
    path: 'access-denied',
    canActivate: [MsalGuard],
    loadComponent: () =>
      import('./pages/access-denied/access-denied').then((m) => m.AccessDenied),
  },
  {
    path: '',
    canActivate: [MsalGuard, roleGuard],
    loadComponent: () => import('./pages/home/home').then((m) => m.Home),
  },
  {
    path: 'applications',
    canActivate: [MsalGuard, roleGuard],
    loadComponent: () =>
      import('./pages/applications/application-list/application-list').then(
        (m) => m.ApplicationList
      ),
  },
  {
    path: 'applications/create',
    canActivate: [MsalGuard, roleGuard, adminGuard],
    loadComponent: () =>
      import('./pages/applications/application-form/application-form').then(
        (m) => m.ApplicationForm
      ),
  },
  {
    path: 'applications/:id/edit',
    canActivate: [MsalGuard, roleGuard, adminGuard],
    loadComponent: () =>
      import('./pages/applications/application-form/application-form').then(
        (m) => m.ApplicationForm
      ),
  },
  {
    path: 'clients',
    canActivate: [MsalGuard, roleGuard],
    loadComponent: () =>
      import('./pages/clients/client-list/client-list').then((m) => m.ClientList),
  },
  {
    path: 'clients/create',
    canActivate: [MsalGuard, roleGuard, adminGuard],
    loadComponent: () =>
      import('./pages/clients/client-form/client-form').then((m) => m.ClientForm),
  },
  {
    path: 'clients/:id/edit',
    canActivate: [MsalGuard, roleGuard, adminGuard],
    loadComponent: () =>
      import('./pages/clients/client-form/client-form').then((m) => m.ClientForm),
  },
  {
    path: 'scopes',
    canActivate: [MsalGuard, roleGuard],
    loadComponent: () =>
      import('./pages/scopes/scope-list/scope-list').then((m) => m.ScopeList),
  },
  {
    path: 'scopes/create',
    canActivate: [MsalGuard, roleGuard, adminGuard],
    loadComponent: () =>
      import('./pages/scopes/scope-form/scope-form').then((m) => m.ScopeForm),
  },
  {
    path: 'scopes/:id/edit',
    canActivate: [MsalGuard, roleGuard, adminGuard],
    loadComponent: () =>
      import('./pages/scopes/scope-form/scope-form').then((m) => m.ScopeForm),
  },
];
